import Swal from 'sweetalert2'
import Vue from 'vue'

/**
 * コンポーネントをマウントできるSweetalert2
 */
class ComponentMountableSwal {
  /**
   * コンストラクタ
   */
  constructor() {
    this.alert = Swal.mixin({
      keydownListenerCapture: true, // モーダル上で表示された時にEscキー押下を先にキャプチャーする
      heightAuto: false, // bodyにheight:auto!importantを付与しない
    })
  }

  /**
   * アラートを表示する
   *
   * @param {Object} options sweetalert2のオプション
   * @property {Object} component マウントするコンポーネント
   * @property {Component} component.parent コンポーネントの親にするコンポーネント
   * @property {Component} component.component マウントするコンポーネント
   * @property {Object} component.props コンポーネントにバインディングするプロパティ
   * @property {String} component.ref 親コンポーネントの$refsに登録するキー
   * @property {Object|Array.<Object>} component.events 購読するイベント
   * @property {String} event.type イベント名
   * @property {Function} event.callback イベント発火時のコールバック関数
   */
  fire(options) {
    if (!options.component) {
      // componentの指定が無い場合は通常のアラートを表示
      return this.alert.fire(options)
    }

    // ネイティブのオプション
    let nativeOption = {}
    Object.entries(options).forEach(([key, value]) => {
      if (key !== 'component') {
        nativeOption[key] = value
      }
    })
    // マウントに関するオプション
    const mountOption = {
      html: '<div id="swal-slot"></div>',
      willOpen: () => {
        const ComponentClass = Vue.extend(options.component.component)
        const instance = new ComponentClass({
          el: '#swal-slot',
          parent: options.component.parent,
          propsData: options.component.props,
        })
        // ref登録
        if (options.component.parent && options.component.ref) {
          options.component.parent.$refs[options.component.ref] = instance
        }
        // イベント購読
        if (options.component.events) {
          if (Array.isArray(options.component.events)) {
            for (const event of options.component.events) {
              instance.$on(event.type, event.callback)
            }
          } else {
            instance.$on(
              options.component.events.type,
              options.component.events.callback
            )
          }
        }
      },
    }
    // オプション統合
    const alertOption = { ...nativeOption, ...mountOption }
    return this.alert.fire(alertOption)
  }
}

export default ComponentMountableSwal
